module.exports = __webpack_public_path__ + "static/media/chargixpro-1.78b10f00.jpg";